/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "@/state/store";
import JwtService from "@/services/jwt.service";
import AppConfig from "@/utils/AppConfig";
import { apiVerbs, headers } from "@/utils/AppConfig";
import router from "../router";
import { SET_LOADING_STATUS, LOGOUT } from "@/state/actions-mutations-type";

Vue.use(VueAxios, axios);
Vue.axios.interceptors.request.use(function (config) {
  store.commit('loader/' + SET_LOADING_STATUS, true);
  return config;
}, function (error) {
  store.commit('loader/' + SET_LOADING_STATUS, false);
  return Promise.reject(error);
});

Vue.axios.interceptors.response.use(function (response) {
  store.commit('loader/' + SET_LOADING_STATUS, false);
  return response;
}, function (error) {
  store.commit('loader/' + SET_LOADING_STATUS, false);
  return Promise.reject(error);
  // if (401 === error.response.status) {
  //   //auth.logout();
  //   store.commit('auth/' + LOGOUT);
  //   console.log("unauthorized!");
  //   router.go('/login?unauthorized=1');
  // }
  // else {
  //   return Promise.reject(error);
  // }
});


var ApiService = {
  array: [1, 2, 3],
  handleResponse(response) {
    var status = response.status;
    if (status == 200 || status == "200") {
      return response.data;
    }
    // eslint-disable-next-line no-empty
    else { }
  },
  handleError(error) {
    console.log("error: ", error);
    if (typeof error.response === 'undefined') {
      return error;
    }

    if (401 === error.response.status) {
      //auth.logout();
      store.commit('auth/' + LOGOUT);
      console.log("unauthorized!");
      router.go('/login?unauthorized=1');
    }
    else {
      return error.response;
    }

    //return error.response;
    //throw new Error(`[Romabravo] ApiService  ${error}`);
  },
  // setHeader() {
  //   Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${JwtService.getToken()}`;
  // },

  async query({ url, method, data = {} }, headers = {}, params = {}, getRawResponse = false) {
    try {
      var options = {
        method,
        url,
        data,
        headers: headers,
        params: params
      };

      const response = await axios(options);
      return getRawResponse ? response : this.handleResponse(response);
      //return typeof getRawResponse !== 'undefined'  ? response : this.handleResponse(response);

    } catch (error) {
      return this.handleError(error);
    }
  },

  
};

export default ApiService;

export const AuthService = {
  async login(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "Login/", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  },
  async verify2Fa(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "account/VerifyCode", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  }
};

export const BookingService = {
  async getAllBookedSeatsByUser() {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `bookings/getAllBookedSeatsByUser`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async getAll(id) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `bookingAdmin/getByEventId/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async getDetailsById(id) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `bookingAdmin/getById/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  }, 
 async removeSeatBooking(eventid, bookingId, seatBookingId) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `bookingAdmin/removeSeatBooking/${eventid}/${bookingId}/${seatBookingId}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },   
   async exportBookingsByEventId(eventid) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `bookingAdmin/exportBookingsByEventId/${eventid}`, method: apiVerbs.get },
      headers(), {}, true);
      
    return response;
  },  
  async create(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "booking", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  },
  async read(id) {
    //ApiService.setHeader();
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `booking/getById/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async update(id, payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `booking/${id}`, method: apiVerbs.put, data: payload },
      headers()
    );
    return response;
  }
};
export const EventsService = {
  async getAll() {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "Events", method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async create(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "EventAdmin", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  },
  async read(id) {
    //ApiService.setHeader();
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `Events/getById/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async getAllAdmin() {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "EventAdmin", method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async readAdmin(id) {
    //ApiService.setHeader();
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `EventAdmin/getById/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async getSeats(id) {
    //ApiService.setHeader();
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `Events/getSeatsByEventId/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async removeReservationByBookingIdAndSeatId(bookingId, seatId) {
    //ApiService.setHeader();
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `Events/removeReservationByBookingIdAndSeatId/${bookingId}/${seatId}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  
  async bookSeatsForEvent(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "Events/bookSeatsForEvent", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  },  
  async update(id, payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `EventAdmin/${id}`, method: apiVerbs.put, data: payload },
      headers()
    );
    return response;
  },
  async delete(id) {
    var response = await ApiService.query(
        { url: AppConfig.baseUrl + `EventAdmin/${id}`, method: apiVerbs.delete },
        headers()
    );
    return response;
}
};
export const ProductRegistrationService = {
  async getAll() {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "productRegistration", method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async getAllByProductId(id) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `productRegistration/getAllByProductId/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async create(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "productRegistration", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  },
  async read(id) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `productRegistration/getById/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async update(id, payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `productRegistration/${id}`, method: apiVerbs.put, data: payload },
      headers()
    );
    return response;
  }
};

export const ValueService = {
  async getAll() {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "values", method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async read(id) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `values/${id}`, method: apiVerbs.get },
      headers()
    );

    return response;
  },
  async create(payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + "values", method: apiVerbs.post, data: payload },
      headers()
    );

    return response;
  },
  async update(id, payload) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `values/${id}`, method: apiVerbs.put, data: payload },
      headers()
    );
    return response;
  },
  async delete(id) {
    var response = await ApiService.query(
      { url: AppConfig.baseUrl + `values/${id}`, method: apiVerbs.delete },
      headers()
    );
    return response;
  }

};



